// src/utils/questionnaireQuestions/catQuestionnaire.js
// COPD Assessment Test (CAT)
// Scale: 0 = best • 5 = worst. Sum (0–40).

const CAT_INTRO =
  "This questionnaire will help you and your healthcare professional measure the impact COPD (Chronic Obstructive Pulmonary Disease) is having on your wellbeing and daily life. Your answers, and test score, can be used by you and your healthcare professional to help improve the management of your COPD and get the greatest benefit from treatment.\nFor each item below, select the box (1 - 5) that best describes you currently.";

const catQuestionnaire = [
  /* 1 ─ Cough */
  {
    id: "catCough",
    titleKey: "catCough.title",
    rangeDescriptionKey: "catCough.rangeDesc",
    fieldType: "range",
    rangePresentation: "choice-row",
    required: true,
    min: 0,
    max: 5,
    step: 1,
    // English fallback (kept for safety; UI should prefer i18n string)
    title: "Cough",
    rangeDescription: "0 = I never cough, 5 = I cough all the time",
    group: "cat",
  },

  /* 2 ─ Phlegm */
  {
    id: "catPhlegm",
    titleKey: "catPhlegm.title",
    rangeDescriptionKey: "catPhlegm.rangeDesc",
    fieldType: "range",
    rangePresentation: "choice-row",
    required: true,
    min: 0,
    max: 5,
    step: 1,
    title: "Phlegm",
    rangeDescription:
      "0 = No phlegm in my chest at all, 5 = My chest is completely full of phlegm",
    group: "cat",
  },

  /* 3 ─ Chest tightness */
  {
    id: "catChestTightness",
    titleKey: "catChestTightness.title",
    rangeDescriptionKey: "catChestTightness.rangeDesc",
    fieldType: "range",
    rangePresentation: "choice-row",
    required: true,
    min: 0,
    max: 5,
    step: 1,
    title: "Chest tightness",
    rangeDescription:
      "0 = My chest does not feel tight at all, 5 = My chest feels very tight",
    group: "cat",
  },

  /* 4 ─ Breathlessness on exertion */
  {
    id: "catBreathlessness",
    titleKey: "catBreathlessness.title",
    rangeDescriptionKey: "catBreathlessness.rangeDesc",
    fieldType: "range",
    rangePresentation: "choice-row",
    required: true,
    min: 0,
    max: 5,
    step: 1,
    title: "Breathlessness",
    rangeDescription:
      "0 = Not breathless, 5 = Very breathless when walking up a hill or one flight of stairs",
    group: "cat",
  },

  /* 5 ─ Activity limitation at home */
  {
    id: "catActivities",
    titleKey: "catActivities.title",
    rangeDescriptionKey: "catActivities.rangeDesc",
    fieldType: "range",
    rangePresentation: "choice-row",
    required: true,
    min: 0,
    max: 5,
    step: 1,
    title: "Activities",
    rangeDescription:
      "0 = Not limited doing any activities at home, 5 = Very limited doing activities at home",
    group: "cat",
  },

  /* 6 ─ Confidence leaving home */
  {
    id: "catConfidence",
    titleKey: "catConfidence.title",
    rangeDescriptionKey: "catConfidence.rangeDesc",
    fieldType: "range",
    rangePresentation: "choice-row",
    required: true,
    min: 0,
    max: 5,
    step: 1,
    title: "Confidence",
    rangeDescription:
      "0 = Completely confident, 5 = Not at all confident leaving home because of my lung condition",
    group: "cat",
  },

  /* 7 ─ Sleep quality */
  {
    id: "catSleep",
    titleKey: "catSleep.title",
    rangeDescriptionKey: "catSleep.rangeDesc",
    fieldType: "range",
    rangePresentation: "choice-row",
    required: true,
    min: 0,
    max: 5,
    step: 1,
    title: "Sleep",
    rangeDescription: "0 = I sleep soundly, 5 = I don't sleep soundly",
    group: "cat",
  },

  /* 8 ─ Energy level */
  {
    id: "catEnergy",
    titleKey: "catEnergy.title",
    rangeDescriptionKey: "catEnergy.rangeDesc",
    fieldType: "range",
    rangePresentation: "choice-row",
    required: true,
    min: 0,
    max: 5,
    step: 1,
    title: "Energy",
    rangeDescription: "0 = I have lots of energy, 5 = I have no energy at all",
    group: "cat",
  },
];

catQuestionnaire.metadata = {
  titleKey: "title",
  title: "CAT",
  introKey: "intro",
  intro: CAT_INTRO,
};

export default catQuestionnaire;
